import axios from "axios";
import dayjs from 'dayjs';
import { CUSTOMER_API_URL } from "../constants";
import { Setting } from "../App";
import { SubscriptionsApiType } from '../types/api/subscriptions-api-type';

export const useRecentlyContracted = (setting: Setting) => {
  const recentlyContracted = (
    success: (flag: boolean) => void,
    cancelDate: (message: string) => void,
    failed?: (message: string) => void,
  ) => {
    (async () => {
      try {
        // getSubscriptionsの中に契約作成日時が存在するので取得する
        const response = await axios.post(
          `${CUSTOMER_API_URL}?action=getSubscriptions`,
          {},
          { headers: { Authorization: setting.token } }
        );

        const subscriptions = (response.data as SubscriptionsApiType).filter(
          (subscription) => subscription.status === 'ACTIVE' || subscription.status === "PAUSED"
        );
        if (subscriptions.length === 0) return;

        const subscription = subscriptions[0];
        const createdAt = subscription.createdAt;
        // 解約可能な日を計算
        const cancelPossibleDate = dayjs(createdAt).add(8, 'day')
        // 解約負荷ならフラグを立てる
        const isRecentlyContracted = dayjs().isBefore(cancelPossibleDate, 'day');
        success(isRecentlyContracted);
        cancelDate(cancelPossibleDate.format('M月D日'));

      } catch (e) {
        if (failed) {
          failed(e.message);
        }
      }
    })();
  };

  return {
    recentlyContracted,
  };
};
